<template>
    <!-- 单点登录 -->
    <div></div>
</template>
<script>
    import apiLoginPage from '@/api/login-page/index'
    import {saveToken} from '@/utils/cache'

    export default {
        name: '',
        data() {
            return {
                loading: true,
            }
        },
        methods: {
            checkLogin(reqPath) {
                let param = {
                    key: reqPath,
                }
                apiLoginPage.netIdLogin(param, {timeout: 60000}).then(res => {
                    saveToken(res.data)
                    this.$store.dispatch('mars/user/getUserInfo')
                    this.$router.push({path: 'home'})
                }).catch((err) => {
                    console.log('绑定用户出错了' + err)
                })
            },
        }
        ,
        mounted() {

            let this_url = location.href
            if (this_url.substr(-5) === '#/sso' && this_url.indexOf("?ticket") > -1) {
                let arr = this_url.split("?")
                arr[0] = arr[0] + '#/sso?'
                arr[1] = arr[1].replace('#/sso', '')
                let newUrl = arr.join('')
                window.location.href = newUrl
            } else {
                let netIdPath = process.env.VUE_APP_NETID_LOGIN
                let ticket = this.$route.query.ticket
                console.log(netIdPath)
                if (ticket) {
                    // http://192.168.50.204:8088/#/sso?ticketId=4444===>收费门户地址 ?service=http://192.168.50.204:8088/sso&ticketId=4444
                    this.checkLogin(netIdPath + 'cas/serviceValidate?service=' + this_url.replace('/#', '').replace('?', '&').replace('%2F', ''))
                } else {
                    // netid地址 ?service=http://192.168.50.204:8088/sso
                    window.location.href = netIdPath + 'cas/login?service=' + this_url.replace('/#', '')
                }
            }
        }
        ,
    }
</script>
<style lang="scss" scoped></style>
